module.exports = __webpack_public_path__ + "static/zenva_css-9735fc4f6976e8d5b8ddd8aa042b84f5.pdf";